const KEY = "buildflow.fieldmode";
const EVENT = "bf:fieldmode";

export function getFieldMode() {
  return localStorage.getItem(KEY) === "1";
}

export function setFieldMode(on) {
  localStorage.setItem(KEY, on ? "1" : "0");
  document.documentElement.classList.toggle("hc", on);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: on }));
}

export function subscribeFieldMode(cb) {
  const handler = (e) => cb(e.detail ?? getFieldMode());
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
